import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

FleetContractListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialFilter: PropTypes.object,
};

function FleetContractListFilterView({ onCancel, onApply, closeDropdown, initialFilter }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterContractRole, setFilterContractRole] = useState('');
  const [filterContractType, setFilterContractType] = useState('');
  const [filterPrimaryRole, setFilterPrimaryRole] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterHasAppendices, setFilterHasAppendices] = useState('');
  const [filterDateFilter, setFilterDateFilter] = useState(null);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  useEffect(() => {
    setFilterQ(initialFilter?.q);
    setFilterContractRole(initialFilter?.contractRole);
    setFilterContractType(initialFilter?.contractType);
    setFilterPrimaryRole(initialFilter?.primaryRole);
    setFilterStatus(initialFilter?.status);
    setFilterHasAppendices(initialFilter?.hasAppendices);
    setFilterDateFilter(initialFilter?.dateFilter);
    setFilterFrom(initialFilter?.from);
    setFilterTo(initialFilter?.to);
  }, [initialFilter]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: filterQ,
      contractRole: filterContractRole,
      contractType: filterContractType,
      primaryRole: filterPrimaryRole,
      status: filterStatus,
      hasAppendices: filterHasAppendices,
      dateFilter: filterDateFilter,
      from: filterFrom,
      to: filterTo,
    };
    if (onApply) onApply(newFilter);
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      contractRole: '',
      contractType: '',
      primaryRole: '',
      status: '',
      hasAppendices: '',
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    };
    if (onCancel) onCancel(newFilter);
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 p-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã hợp đồng, số hợp đồng, tên đối tác"
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* loc theo mau hop dong */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Mẫu hợp đồng')}
          <KTBSDropdown
            name="contractRole"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.contractRoleOptions, { value: filterContractRole })
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterContractRole}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.contractRoleOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterContractRole(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* loc theo loai hop dong */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Loại hợp đồng')}
          <KTBSDropdown
            name="contractType"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.contractTypeOptions, { value: filterContractType })
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterContractType}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.contractTypeOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterContractType(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* loc theo vai tro doi tac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Vai trò đối tác')}
          <KTBSDropdown
            name="primaryRole"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.agencyRoleOptions, { value: filterPrimaryRole })
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterPrimaryRole}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.agencyRoleOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterPrimaryRole(value);
            }}
            isDropdownForm={true}
          />
        </div>
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạng thái hợp đồng')}
          <KTBSDropdown
            name="status"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.contractOptions, { value: filterStatus })?.name ??
                  'Tất cả'}
              </button>
            }
            selectedValue={filterStatus}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.contractOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạng thái phụ lục')}
          <KTBSDropdown
            name="status"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.appendixOptions, { value: filterHasAppendices })?.name ??
                  'Tất cả'}
              </button>
            }
            selectedValue={filterHasAppendices}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.appendixOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterHasAppendices(value);
            }}
            isDropdownForm={true}
          />
        </div>
        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel('Khoảng thời gian')}
          <CustomDateRangePicker
            inlineMode={true}
            toggleElementBorderRadius={5}
            initialValue={filterDateFilter}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
          />
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default FleetContractListFilterView;
